'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _availabilityDigitalBlock = require('@bibliocommons/availability-digital-block');

var _availabilityDigitalBlock2 = _interopRequireDefault(_availabilityDigitalBlock);

var _sharedEresourceLink = require('@bibliocommons/shared-eresource-link');

var _sharedEresourceLink2 = _interopRequireDefault(_sharedEresourceLink);

var _availabilityPhysicalBlock = require('@bibliocommons/availability-physical-block');

var _availabilityPhysicalBlock2 = _interopRequireDefault(_availabilityPhysicalBlock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  bib: _reactImmutableProptypes2.default.map.isRequired,
  availabilityStatus: _reactImmutableProptypes2.default.map.isRequired,
  availabilityDetailActions: _react.PropTypes.objectOf(_react.PropTypes.func).isRequired,
  showAvailabilityLink: _react.PropTypes.bool,
  showAvailabilityStatus: _react.PropTypes.bool,
  showHoldCount: _react.PropTypes.bool,
  showCheckDigitalAvailabilityButton: _react.PropTypes.bool,
  reciprocalRank: _react.PropTypes.number
};

var BibBlock = function BibBlock(props) {
  if (props.availabilityStatus.get('localisedStatus') === 'DELETED') {
    return null;
  }

  var bib = props.bib,
      availabilityStatus = props.availabilityStatus,
      availabilityDetailActions = props.availabilityDetailActions,
      showAvailabilityLink = props.showAvailabilityLink,
      showAvailabilityStatus = props.showAvailabilityStatus,
      showCheckDigitalAvailabilityButton = props.showCheckDigitalAvailabilityButton,
      showHoldCount = props.showHoldCount,
      reciprocalRank = props.reciprocalRank;

  var briefInfo = bib.get('briefInfo');

  switch (props.availabilityStatus.get('bibType')) {
    case 'PHYSICAL':
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_availabilityPhysicalBlock2.default, {
          holdable: bib.getIn(['policy', 'holdable']),
          bib: briefInfo,
          availabilityStatus: availabilityStatus,
          availabilityDetailActions: availabilityDetailActions,
          showAvailabilityStatus: showAvailabilityStatus,
          showAvailabilityLink: showAvailabilityLink,
          showHoldCount: showHoldCount,
          reciprocalRank: reciprocalRank })
      );
    case 'DIGITAL':
      return _react2.default.createElement(_availabilityDigitalBlock2.default, _extends({}, props, {
        bib: briefInfo,
        serviceAvailable: bib.getIn(['policy', 'materialPolicy', 'healthy']),
        reciprocalRank: reciprocalRank }));
    case 'DIGITAL_RESOURCE':
      return _react2.default.createElement(_sharedEresourceLink2.default, {
        format: briefInfo.get('format'),
        showHoldCount: showHoldCount,
        eresourceDescription: availabilityStatus.get('eresourceDescription'),
        eresourceUrl: availabilityStatus.get('eresourceUrl') });
    default:
      return null;
  }
};

BibBlock.propTypes = propTypes;

exports.default = BibBlock;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/availability-bib-block/lib/components/BibBlock.component.js
// module id = 1167
// module chunks = 0